/**
 * @generated SignedSource<<5bba458fc1279f6624b04b67ab4f1eca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackCastPanelQueryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackCastPanelFeedbackFragment" | "FeedbackCastPanelOwnFeedbackFragment" | "GiveFeedbackInputFeedbackButtonsQueryFragment">;
  readonly " $fragmentType": "FeedbackCastPanelQueryFragment";
};
export type FeedbackCastPanelQueryFragment$key = {
  readonly " $data"?: FeedbackCastPanelQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackCastPanelQueryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "proposalId",
  "variableName": "proposalId"
},
v1 = {
  "kind": "Variable",
  "name": "address",
  "variableName": "address"
},
v2 = {
  "kind": "Variable",
  "name": "skipAddress",
  "variableName": "skipAddress"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "address"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "proposalId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skipAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedbackCastPanelQueryFragment",
  "selections": [
    {
      "args": [
        (v0/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "FeedbackCastPanelFeedbackFragment"
    },
    {
      "args": [
        (v1/*: any*/),
        (v0/*: any*/),
        (v2/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "FeedbackCastPanelOwnFeedbackFragment"
    },
    {
      "args": [
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "GiveFeedbackInputFeedbackButtonsQueryFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "e3ad469737e07edf42f2a000dc89c7a0";

export default node;
